import React from 'react'
import { Skeleton } from 'antd'
import Editor from '../../../../../components/common/Editor/Editor'
import Title from 'antd/es/typography/Title'
import './component-with-editor.scss'

const ComponentWithEditor = ({
    children,
    name,
    content,
    language,
    patternsList,
    selectedSnippets,
    showEditor = true,
    loading = false,
    editorWrapper,
    editorProps = {},
}) => {
    // Don't exit early when using editorWrapper, as Form.Item will control the content
    if (!showEditor || (!content && !editorWrapper)) {
        return children
    }

    // Create the editor element with all props
    const editorElement = (
        <Editor
            className='mb-0'
            title={
                <Title level={3} style={{ margin: '8px 0', fontSize: '1rem' }}>
                    {name}
                </Title>
            }
            value={content}
            language={language}
            readOnly={true}
            showPatternId={false}
            patternsList={patternsList}
            selectedSnippets={selectedSnippets}
            {...editorProps}
        />
    )

    const wrappedEditor = editorWrapper ? editorWrapper(editorElement) : editorElement

    return (
        <div className='component-with-editor__container'>
            <div className='component-with-editor__content'>{children}</div>
            <div className='component-with-editor__editor'>
                {loading ? (
                    <Skeleton active />
                ) : (
                    wrappedEditor
                )}
            </div>
        </div>
    )
}

export default ComponentWithEditor 